import axios from 'axios'

const path = 'signature'

export default {
  async getXmlTemplates() {
    const resp = await axios.get(`${path}/xmlTemplates`)
    return resp.data
  }
}
